import { Helmet } from "react-helmet";

import { useParams } from "react-router-dom";

import { useEffect, useState } from "react";
import pb from "../../../lib/pocketbase";

import Container from "../../../components/Container";
import { IExpenseListWithTotalRecord } from "./Lists";
import { cn, createSlug } from "../../../lib/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { format } from "date-fns";
import NewExpense from "../../../components/studio/expenses/NewExpense";
import Button from "../../../components/form/button";
import BackButton from "../../../components/form/BackButton";
import ExpenseOverview from "../../../components/studio/expenses/Overview";
import { IExpenseRecord } from "../../../lib/types";
import EditList from "../../../components/studio/expenses/editList";
import { config } from "../../../config";
import { useToast } from "../../../components/ui/use-toast";

export default function ExpenseList() {
    const id = useParams().id;
    const [list, setList] = useState<IExpenseListWithTotalRecord>();
    const [expenses, setExpenses] = useState<IExpenseRecord[]>();
    const { toast } = useToast();
    async function load() {
        if (!id) return;
        const l: IExpenseListWithTotalRecord = await pb.collection("expenseList").getOne(id);

        const exp: IExpenseRecord[] = await pb.collection("expense").getFullList({
            filter: `list="${id}"`,
            expand: `type`,
            sort: "-date"
        });

        l.total = exp.reduce((total, expense) => {
            if (expense.income) return total + expense.amount * expense.price;
            else return total - expense.amount * expense.price;
        }, 0);

        setExpenses(exp);
        setList(l);
    }

    function copyUrl() {
        navigator.clipboard?.writeText(`${config.base}/expenses/${createSlug(list?.name || "")}/${list?.id}`);
        toast({
            title: "🤩 Successfully copied url!",
            description: "You have successfully copied the url of this expenses list."
        });
    }

    useEffect(() => {
        load();
    }, []);
    return (
        <>
            <Helmet>
                <title>ReinVB Studio — Expenses — List</title>
            </Helmet>
            <Container variant={"large"} className="my-8">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <BackButton />
                        <h2 className="text-2xl font-medium">{list?.name}</h2>
                        {list?.public && (
                            <Button onClick={copyUrl} variant={"ghost"} size={"ghost"}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-6 w-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15m0-3l-3-3m0 0l-3 3m3-3V15" />
                                </svg>
                            </Button>
                        )}
                    </div>
                    <div className="flex items-center gap-2">
                        <EditList list={list} reload={() => load()}>
                            <Button variant={"ghost"} size={"ghost"}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-6 w-6">
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
                                    />
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                            </Button>
                        </EditList>
                        <NewExpense defaultList={list?.id} reload={() => load()}>
                            <Button variant={"ghost"} size={"ghost"}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-6 w-6">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" />
                                </svg>
                            </Button>
                        </NewExpense>
                    </div>
                </div>
                <ExpenseOverview expenses={expenses} reload={() => load()} />
            </Container>
        </>
    );
}
